export const menuData = [
  { title: "Home", link: "/" },
  { title: "Rentas", link: "/rentals" },
  { title: "Ventas", link: "/sales" },
];
